import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotification } from '@eye-able/ui';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

/** Delete a custom governance policy (`DELETE /policies?id=…`). */
export function useDeletePolicy() {
  const queryClient = useQueryClient();
  const notification = useNotification();
  const { t } = useInlineTranslation();

  return useMutation({
    mutationFn: (id: number) => fetchWrapper.delete<void>(api.policies, { id }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [api.policies] });
      notification.success(t('policyDeletedSuccess'));
    },
  });
}
